import configuration from '@/taskpane/common/configuration'
import addRecipientsHandler from './handlers/add-recipients-handler'
import insertOnCursorHandler from './handlers/insert-on-cursor-handler'
import setEmailSubjectHandler from './handlers/set-email-subject-handler'
import setEmailBodyHandler from './handlers/set-email-body-handler'
import setCategoryHandler from './handlers/set-category-handler'
import retrieveFilingContentsHandler from './handlers/retrieve-filing-contents-handler'
import retrieveDraftEventIdHandler from './handlers/retrieve-draft-event-id-handler'
import saveEmailTrackingInfoHandler from './handlers/save-email-tracking-handler'
import applyEmailTemplateHandler from './handlers/apply-email-template-handler'
import openComposeViewHandler from './handlers/open-compose-view-handler'
import openEmailWindowHandler from './handlers/open-email-window-handler'
import sidebarLoginRequestedHandler from './handlers/sidebar-login-requested-handler'
import sidebarLoginCompleteHandler from './handlers/sidebar-login-complete-handler'
import sidebarConnectedHandler from './handlers/sidebar-connected-handler'
import retrieveAttachmentsHandler from './handlers/retrieve-attachments-handler'
import emailPostSentCallbackHandler from './handlers/email-post-sent-callback-handler'
import sidebarLogoutHandler from './handlers/sidebar-logout-handler'
import graphLoginRequestCallbackHandler from './handlers/graph-login-request-callback-handler'
import establishGraphAccessHandler from './handlers/graph-establish-access-handler'
import mailItemOpenProcessedHandler from './handlers/mail-item-open-processed-handler'
import eventItemOpenProcessedHandler from './handlers/event-item-open-processed-handler'
import replyTrackingChangedHandler from './handlers/reply-tracking-changed-handler'
import setViewRequestHandler from './handlers/set-view-request-handler'

export default function addSidebarListener() {
  window.addEventListener('message', handleSidebarMessage, false)
}

function handleSidebarMessage(event) {
  if (!isValidOrigin(event.origin)) return

  switch (event.data.type) {
    case 'SidebarLoginRequested':
      sidebarLoginRequestedHandler(event.data.args)
      break
    case 'SidebarLoginComplete':
      sidebarLoginCompleteHandler(event.data.args)
      break
    case 'SidebarConnected':
      sidebarConnectedHandler(event.data.args)
      break
    case 'Logout':
      sidebarLogoutHandler()
      break
    case 'ApplyEmailTemplate':
      applyEmailTemplateHandler(event.data.args)
      break
    case 'InsertOnCursor':
      insertOnCursorHandler(event.data.args)
      break
    case 'OpenComposeView':
      openComposeViewHandler(event.data.args)
      break
    case 'SaveEmailTrackingInfo':
      saveEmailTrackingInfoHandler(event.data.args)
      break
    case 'RetrieveAttachments':
      retrieveAttachmentsHandler(event.data.args)
      break
    case 'AddRecipients':
      addRecipientsHandler(event.data.args)
      break
    case 'SetEmailSubject':
      setEmailSubjectHandler(event.data.args)
      break
    case 'SetEmailBody':
      setEmailBodyHandler(event.data.args)
      break
    case 'OpenEmailWindow':
      openEmailWindowHandler(event.data.args)
      break
    case 'RetrieveFilingContents':
      retrieveFilingContentsHandler(event.data.args)
      break
    case 'SetZynBitCategory':
      setCategoryHandler(event.data.args)
      break
    case 'RetrieveDraftEventId':
      retrieveDraftEventIdHandler()
      break
    case 'EmailPostSentCallback':
      emailPostSentCallbackHandler(event.data.args)
      break
    case 'ReplyTrackingChanged':
      replyTrackingChangedHandler(event.data.args)
      break
    case 'GraphLoginRequestCallback':
      graphLoginRequestCallbackHandler(event.data.args)
      break
    case 'EstablishGraphAccess':
      establishGraphAccessHandler()
      break
    case 'MailItemOpenProcessed':
      mailItemOpenProcessedHandler(event.data.args)
      break
    case 'EventItemOpenProcessed':
      eventItemOpenProcessedHandler()
      break
    case 'SetViewRequest':
      setViewRequestHandler(event.data.args)
      break
    case 'FullscreenViewAvailable':
      // Intentionally unused in OWA: the dialog opens on SetViewRequest, not on
      // availability. The chrome extension uses this to reveal its expand toggle.
      break
  }
}

function isValidOrigin(origin: string): boolean {
  return origin === configuration.CIRRUS_PORTAL
}
